import { useContext, useEffect } from 'react';
import { AppContext } from '../../context/AppContext/context';

function useInSplitCheckout(isInSplitCheckout?: boolean) {
  const { state, dispatch } = useContext(AppContext);

  useEffect(() => {
    if (typeof isInSplitCheckout !== 'boolean') return undefined;

    dispatch({ type: 'SET_IS_IN_SPLIT_CHECKOUT', payload: isInSplitCheckout });

    return () => {
      dispatch({ type: 'SET_IS_IN_SPLIT_CHECKOUT', payload: false });
    };
  }, [dispatch, isInSplitCheckout]);

  return state.checkout.isInSplitCheckout;
}

export default useInSplitCheckout;
